import axios from "axios";
import _ from "lodash";
import Endpoint from "../../constant/endpoint";
const state = {
  loading: false,
  error: {},
  userProfile: [],
  users: []
};
  
const getters = {
  getterUserProfile: (state) => {
    return state.userProfile;
  },
  getterUsers: (state) => {
    return state.users;
  },
};

const actions = {
  // action
  getUserProfile(context, username) {
      const config = {
        params: {
          username : username
        },  
      };
      const url = Endpoint.users()+"/profile/find_by_username";
      axios
        .get(url, config)
        .then((res) => {
          const data = _.get(res, "data", []);
          context.commit("SUCCESS_GET_USER_PROFILE", { data });
        })
        .catch((e) => {
          context.commit("ERROR_GET_USER_PROFILE", { error: e });
        })
        .finally(() => {
          context.commit("LOADING_GET_USER_PROFILE", { loading: false });
        });
  }, 
  updateProfile(context,
    {
      username,
      password,
      firstName,
      lastName,
      nickname,
      email,
      address,
      telephone,
      gender,
      city,
      dayOfBirth,
      country
    }){
      context.commit("LOADING", true);
      const url = Endpoint.users()+"/auth/update_user_profile";
    // const url ="http://192.168.1.50:8081/api/v1/auth/update_user_profile";
     axios
      .put(
        url,
        {
          username,
          password,
          firstName,
          lastName,
          nickname,
          email,
          address,
          telephone,
          gender,
          city,
          dayOfBirth,
          country
        },
        { "content-type": "application/json" }
      )
      .then((res) => {
        if (res.data) {
          context.commit("LOGIN_ERROR", {
            status: 201,
            username,
            message: "update successful",
          });
        }
      })
      .catch((error) => {
        // reg fail
        context.commit("LOGIN_ERROR", { error });
      })
      .finally(() => {
        context.commit("LOADING", false);
      });

  },
  getUsers(context) {
    const url = Endpoint.users()+"/profile/find_all";
    axios
      .get(url)
      .then((res) => {
        const data = _.get(res, "data", []);
        context.commit("SUCCESS_GET_USERS", { data });
      })
      .catch((e) => {
        context.commit("ERROR_GET_USER_PROFILE", { error: e });
      })
      .finally(() => {
        context.commit("LOADING_GET_USER_PROFILE", { loading: false });
      });
  }, 
  async deleteUser(context, username) {
    const config = {
      data: {
        username: username
      }, 

    };
    const url = Endpoint.users()+"/auth/delete_account";
    await axios
      .delete(url,config)
      .then(res => {
        if (res.data) {
          context.commit("LOGIN_ERROR", {
            status: 201,
            username,
            message: "login successful",
          });
        }
      })
      .catch(error => {
        context.commit("LOGIN_ERROR", { error });
      });
  },
  changePassword(context, data){
    context.commit("LOADING", true);
    const url = Endpoint.users()+"/auth/password";

    axios.put(url, data,
      {
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("accessToken")
        },
      }
    )
    .then((res) => {
      if (res.data) {
        context.commit("LOGIN_ERROR", {
          status: 201,
          message: "update password successful",
        });
      }
    })
    .catch((error) => {
      // reg fail
      context.commit("LOGIN_ERROR", { error });
    })
    .finally(() => {
      context.commit("LOADING", false);
    });
  }
};

const mutations = {
  SUCCESS_GET_USER_PROFILE(state, payload) {
    state.userProfile = payload.data;
  },
  SUCCESS_GET_USERS(state, payload) {
    state.users = payload.data;
  },
  ERROR_GET_USER_PROFILE(state, payload) {
    state.error = {
      ...payload,
    };
  },
  LOADING_GET_USER_PROFILE(state, payload) {
    state.loading = payload.loading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
  